import { action, observable, makeObservable } from 'mobx';

import { pigIndexes } from '../enums/pigColors';

class OddStore {
  oddData = {
    [pigIndexes.red]: null,
    [pigIndexes.blue]: null,
    [pigIndexes.yellow]: null,
  };

  isShowCloud = true;

  partnerWageringOdd = 0;

  constructor() {
    makeObservable(this, {
      isShowCloud: observable,
      oddData: observable.deep,
      partnerWageringOdd: observable,
      setOddData: action.bound,
      resetOddData: action.bound,
      setPartnerWageringOdd: action.bound,
    });
  }

  setOddData(index, odd) {
    this.oddData = { ...this.oddData, [index]: odd };
  }

  setIsShowCloud(boolValue) {
    this.isShowCloud = boolValue;
  }

  resetOddData() {
    this.oddData = {
      [pigIndexes.red]: null,
      [pigIndexes.blue]: null,
      [pigIndexes.yellow]: null,
    };
  }

  setPartnerWageringOdd(value) {
    this.partnerWageringOdd = value;
  }
}

export const oddStore = new OddStore();
